<script setup lang="ts">
import MButton from "../../components/medicus/MButton";
import MLayoutStack from "../../components/medicus/MLayoutStack";
</script>
<template>
  <m-layout-stack>
    <p>
      The Account setup link you have clicked on has expired. Please contact your local
      administrator to request a new link.
    </p>
    <m-button :to="{ name: 'login' }" :permission="true"> Go to login page</m-button>
  </m-layout-stack>
</template>
